import { Component, effect, input, viewChild, ViewContainerRef } from '@angular/core';
import { RatingsCategoryIconConfigMap, RatingsCategoryRanks, RatingsIconType } from '../horizon-ratings-utils';
import { IconComponent } from '@app/shared';
import { IconProperties, IconTypes } from '@app/shared/components/icon';

@Component({
    selector: 'topo-horizon-category-rank-icon',
    template: `
    <ng-template #iconContainer />
  `,
    standalone: false
})
export class CategoryRankIconComponent {
  rank = input<RatingsCategoryRanks>();
  size = input<number>(16); // pixel value so support for svg icon components
  color = input<string>('var(--neutral-color-900)');
  private iconContainer = viewChild('iconContainer', { read: ViewContainerRef });

  icon$ = effect(() => {
    const rank = this.rank();

    if (!rank) {
      return;
    }

    const iconContainer = this.iconContainer();
    const iconConfig = RatingsCategoryIconConfigMap[rank];

    if (!iconContainer || !iconConfig) {
      return;
    }

    iconContainer.clear();

    if (iconConfig.type === RatingsIconType.System) {
      const componentRef = iconContainer.createComponent(IconComponent);
      const iconProps: IconProperties = {
        path: iconConfig.path,
        type: IconTypes.SystemIcon,
        style: {
          fontSize: `${this.size()}px`,
          color: this.color()
        }
      };
      componentRef.setInput('props', iconProps);
    } else if (iconConfig.type === RatingsIconType.SvgComponent) {
      const componentRef = iconContainer.createComponent(iconConfig.component());
      componentRef.setInput('size', this.size());
      componentRef.setInput('color', this.color());
    }
  });
}
